import * as React from 'react';
import ReactDataSheet from 'react-datasheet';
import {WithTranslation, withTranslation} from 'react-i18next';
import { PropsWithChildren } from 'react';

export interface GridElement extends ReactDataSheet.Cell<GridElement, string> {
  value: string | null;
  readOnly?: boolean;
  tooltip?: string;
  additionalData?: string;
}

export const RowRenderer = (props: any) => {
  const {
    row,
    isSelected,
    onSelectChanged
  } = props;
  return (
    <tr>
      <td headers="data-sheet-checkbox" className="check-cell">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => onSelectChanged(row, e.target.checked)}
        />
      </td>
      {props.children}
    </tr>
  );
};

const getCellStyle = (col: number, isReadOnly?: boolean, isAdjustment?: boolean, isSelected?: boolean, isAdjustmentRowActive?: boolean) => {
  let className = col < 2 ? 'cell aligned-left' : 'cell aligned-right';

  if (isAdjustment) {
    if (!isSelected && col > 1 && isAdjustmentRowActive) className = className.concat(' active-cell');
    else if (!isSelected && col > 1 && !isAdjustmentRowActive) className = className.concat(' inactive-adjustment');
    else if (isSelected && col > 1) className = className.concat(' cell-selected');

    if (!isAdjustmentRowActive) className = className.concat(' text-inactive');

    return className;
  }

  if (isSelected) className = className.concat(' cell-selected');
  else if (!isReadOnly) className = className.concat(' active-cell');

  return className;
};

const getTableData = (props: any, isReadOnly?: boolean, isAdjustment?: boolean, selectedRows?: boolean[]) => (
  <td
    onMouseDown={(isAdjustment && selectedRows && selectedRows[props.row] === false) ? undefined : props.onMouseDown}
    onMouseOver={(isAdjustment && selectedRows && selectedRows[props.row] === false) ? undefined : props.onMouseOver}
    onDoubleClick={isReadOnly || (isAdjustment && props.col < 2) || (isAdjustment && selectedRows && selectedRows[props.row] === false) ? undefined : props.onDoubleClick}
    className={getCellStyle(props.col, isReadOnly, isAdjustment, props.selected, selectedRows && selectedRows[props.row] === true ? true : undefined)}
  >
    {props.children}
  </td>
);

export const CellRenderer = (props: any) => (
  <>
    {getTableData(props, props.isReadonly, props.isAdjustment, props.selectedRows)}
  </>
);

interface SheetRendererProps extends React.PureComponent, WithTranslation {
  className: string;
  columns: { label: string; width: string }[];
  isAdjustment?: boolean;
  allSelected: boolean;
  onAllRowSelectClick: () => void;
}

class SheetRenderer extends React.PureComponent<PropsWithChildren<SheetRendererProps>> {

  render() {
    const colSplit = 2;

    return (
      <table className="data-grid rate-table">
        <thead>
          <tr>
            {this.props.isAdjustment && (
            <th id="data-sheet-checkbox" className="check-cell">
              <input
                checked={this.props.allSelected}
                onChange={() => this.props.onAllRowSelectClick()}
                type="checkbox"
              />
            </th>
            )}
            {
              this.props.columns.map((col, index) => (
                <th key={col.label} className={`rate-table-header ${index < colSplit ? 
                    'aligned-left' : 'aligned-right'}`} style={{ width: col.width }}>
                  {this.props.t(col.label as keyof Translation)}</th>
              ))
            }
          </tr>
        </thead>
        <tbody>
          {this.props.children}
        </tbody>
      </table>
    );
  }
}

export default withTranslation()(SheetRenderer);
